module.exports = __webpack_public_path__ + "img/logo-SAFEST_hi-res.b10ebd97.png";